import type { Middleware, SWRConfiguration, SWRHook, BareFetcher, SWRResponse } from 'swr';

import type { FetchCrowdForecastResponse } from 'types/kbygApi';
import createDayHourlyData from 'reducers/components/graphs/helpers/createDayHourlyData';
import createFiveDayHourlyWave from 'reducers/components/graphs/helpers/createFiveDayHourlyData';

export const transformCrowdData = (data: FetchCrowdForecastResponse | null) => {
  const mapFunc = (p: any) => ({
    ...p,
  });
  return {
    days: data?.data?.predicted ? createDayHourlyData(data?.data?.predicted, 16, 1, mapFunc) : null,
    hourly: data?.data?.predicted ? createFiveDayHourlyWave(data?.data?.predicted, mapFunc) : null,
    observed: data?.data?.observed || null,
    utcOffset: data?.data?.predicted?.[0]?.utcOffset,
  };
};

export const transformCrowdDataMiddleware: Middleware =
  (useSWRNext: SWRHook) =>
  (
    key,
    fetcher: BareFetcher<any> | null,
    config: SWRConfiguration<any, any, BareFetcher<any>> | undefined,
  ): SWRResponse<any, any> =>
    useSWRNext(
      key,
      async (...args: any[]) => {
        const data = await (fetcher && fetcher(...args));
        return transformCrowdData(data);
      },
      config,
    );
